import { observable, action, computed, toJS, reaction } from 'mobx'
import CatalogProduct, { createStub } from '../Model/CatalogProduct'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class CatalogProductsStore {
    
    @observable
    private item: CatalogProduct | null

    @observable
    private list: Array<CatalogProduct>

    @observable
    private pageCount: number = 0

    private static _instance: CatalogProductsStore

    private constructor() {
        this.list = []

        reaction(
            () => this.list,
            _ => {
                let data = createStub(this.list)
                ActionsLocalService.getInstance().setExportData(ExportType.CatalogProducts, data)
            }
        )
    }

    public static getInstance(): CatalogProductsStore {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    setList(list: Array<CatalogProduct>): void {
        this.list = list
    }

    @computed
    get getList(): Array<CatalogProduct> {
        return toJS(this.list)
    }

    @action.bound
    setItem(item: CatalogProduct | null): void {
        this.item = item
    }

    @computed
    get getItem(): CatalogProduct | null {
        return toJS(this.item)
    }

    @action.bound
    setPageCountAll(pageCount: number) {
        this.pageCount = pageCount
    }

    @computed
    get getPageCount() {
        return toJS(this.pageCount)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/CatalogProductsStore.ts